import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { withRouter } from '@/checkout-instore-legacy/utils/withRouter'
import clone from 'lodash/clone'

import { logClickEvent } from '@/checkout-instore-legacy/utils/EventHelper'
import Loader from '@/checkout-instore-legacy/components/Commons/Loader'

import Order from './Order'
import NewOrder from './NewOrder'

class Orders extends Component {
  constructor(props) {
    super(props)

    this.state = {
      editMode: false,
    }
  }

  componentDidMount() {
    if (!this.props.currentOrder) {
      this.props.loadInStoreOrderForm(this.props.vendor)
    }
  }

  handleRecoverOrder = (orderId) => {
    if (!this.state.editMode) {
      this.props.recoverOrder(orderId)
      this.props.router.push('/cart')
    }
  }

  handleToggleEditMode = () => {
    this.setState({ editMode: !this.state.editMode })
  }

  handleNewOrder = () => {
    logClickEvent('new-order-orders-page', 'Admin')
    this.props.newOrder()
    this.props.router.push('/')
  }

  handleRemoveOrder = (orderId) => {
    logClickEvent('remove-order', 'Admin')
    this.props.ordersRemoveOrder(orderId)
  }

  handleRemoveAll = () => {
    logClickEvent('remove-all-orders', 'Admin')
    this.props.ordersRemoveAll()
    this.props.router.push('/')
  }

  render() {
    const { orders, currentOrder, loading } = this.props
    const { editMode } = this.state

    return (
      <div className="flex flex-column flex-auto">
        {loading ? (
          <Loader loading />
        ) : (
          <div className="flex-auto bg-base overflow-auto momentum">
            <header className="flex justify-end">
              {editMode ? (
                <div className="flex-none">
                  <button
                    className="pointer hover-red f6 f4-ns pa4 pa5-ns lh-copy bn bg-transparent light-red"
                    onClick={this.handleRemoveAll}
                  >
                    <FormattedMessage id="pastOrdersRemoveAll" />
                  </button>
                  <button
                    className="pointer hover-c-action-primary f6 f4-ns pa4 pa5-ns lh-copy bn bg-transparent c-action-primary"
                    onClick={this.handleToggleEditMode}
                  >
                    <FormattedMessage id="pastOrdersFinish" />
                  </button>
                </div>
              ) : (
                <div className="flex-none">
                  <button
                    className="pointer hover-c-action-primary f6 f4-ns pa4 pa5-ns lh-copy bn bg-transparent c-action-primary"
                    onClick={this.handleToggleEditMode}
                  >
                    <FormattedMessage id="pastOrdersEdit" />
                  </button>
                </div>
              )}
            </header>

            <div id="order-list">
              {clone(orders)
                .reverse()
                .map((orderForm) => (
                  <Order
                    key={orderForm.orderFormId}
                    order={orderForm}
                    isSelected={currentOrder === orderForm.orderFormId}
                    editMode={this.state.editMode}
                    onRemoveOrder={this.handleRemoveOrder}
                    onRecoverOrder={this.handleRecoverOrder}
                  />
                ))}
            </div>
          </div>
        )}

        <div className="flex-none bt b--black-20">
          <NewOrder onClick={this.handleNewOrder} />
        </div>
      </div>
    )
  }
}

Orders.defaultProps = {
  loading: false,
}

Orders.propTypes = {
  router: PropTypes.object,
  currentOrder: PropTypes.string,
  orders: PropTypes.arrayOf(PropTypes.object).isRequired,
  loadInStoreOrderForm: PropTypes.func.isRequired,
  newOrder: PropTypes.func.isRequired,
  ordersRemoveOrder: PropTypes.func.isRequired,
  ordersRemoveAll: PropTypes.func.isRequired,
  recoverOrder: PropTypes.func.isRequired,
  vendor: PropTypes.object,
  loading: PropTypes.bool,
}

export default withRouter(Orders)
